import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface FeedbackACKProps {
  isOpen: boolean;
  onClose: () => void;
}

const FeedbackACK: React.FC<FeedbackACKProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center z-[200]"
          onClick={(e) => e.target === e.currentTarget && onClose()}
        >
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", duration: 0.4, bounce: 0.3 }}
            className="flex flex-col w-[400px] bg-[#FFFFFF] rounded-[16px] shadow-lg p-6 gap-4 text-center"
            onClick={e => e.stopPropagation()}
          >
            <motion.h2 
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-[16px] font-semibold text-[#222222]"
            >
              Thank you!
            </motion.h2>
            <motion.p 
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.3 }}
              className="text-[14px] text-[#9FA1A7] font-medium"
            >
              Your feedback helps us improve, appreciate the time you took to send us the feedback!
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FeedbackACK;
